import {useQuery} from '@tanstack/react-query'
import {QueryKeyTypes} from '../../../query-manager/QueryKeyTypes'
import {QueryKeyManager} from '../../../query-manager/QueryKeysManager'
import {getHealthRecordChart} from '../HealthRerecodEndpoint'

export const useHealthRecordChart = (requestorId, userId, day) => {
    const {healthRecordKeys} = QueryKeyManager(
        QueryKeyTypes.healthRecord,
        requestorId,
    )
    return useQuery({
        queryKey: healthRecordKeys.chartData({requestorId, userId, day}),
        queryFn: () => getHealthRecordChart(userId, day),
        enabled: !!requestorId && !!userId,
    })
}
